// Legacy alias — org-wide Follow Up settings were folded into the
// per-audience Audiences surface.
import { Redirect } from 'expo-router';

export default function FollowUpSettingsAlias() {
    return <Redirect href="/follow-up/audiences" />;
}
